/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Checkbox } from '@atoms';
import { Form } from '@organisms';

const HideOnMainSiteCheck = ({
  minisiteFormField,
  label,
  labelStyle,
  labelClassName,
  onChange,
  visibility,
  checkButton,
  ...props
}) => {
  const [triggered, setTriggered] = React.useState(false);
  const [checkInitValue, setCheckInitValue] = React.useState(checkButton);

  const handleOnChange = React.useCallback(
    (event) => {
      setTriggered(true);
      // eslint-disable-next-line no-unused-expressions
      onChange?.(event);
    },
    [onChange],
  );

  return (
    <>
      <Form.WithFieldValue name={minisiteFormField}>
        {(value, form) => {
          if (!value?.length || triggered || !checkInitValue) {
            if (!value?.length) {
              setCheckInitValue(true);
              setTriggered(false);
            }
            return;
          }

          form.setFieldsValue({ [props.name]: true });
        }}
      </Form.WithFieldValue>
      <Form.Item valuePropName="checked" {...props}>
        <Checkbox style={labelStyle} className={labelClassName} onChange={handleOnChange}>
          {label}
        </Checkbox>
      </Form.Item>
    </>
  );
};

export default HideOnMainSiteCheck;
